import React, { useState } from 'react';
import { AutoComplete } from 'antd';
import PropTypes from 'prop-types';

import Base from './Base';

const valueExtractor = value => value;

const AntAutoComplete = props => {
  const [autoComplete, setAutoComplete] = useState([]);
  const onSearch = value => {
    const { options } = props;
    const filtered = value
      ? options.filter(option => option.startsWith(value))
      : [];
    setAutoComplete(filtered);
  };

  return (
    <Base
      {...props}
      style={{ width: '100%' }}
      component={AutoComplete}
      dataSource={autoComplete}
      onSearch={onSearch}
      valueExtractor={valueExtractor}
    />
  );
};

AntAutoComplete.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string),
};

AntAutoComplete.defaultProps = {
  options: [],
};

export default AntAutoComplete;
